import { useEffect, useState } from "react";

/**
 * Retourne `value` après un délai d'inactivité — l'utilisateur doit s'arrêter
 * de taper pendant `delay` ms avant que la valeur ne soit propagée. Sert de
 * fondation aux hooks lookup search-as-you-type (`useDrugsLookupSearch`,
 * `useDiseasesLookupSearch`) qui ne doivent pas fire un GET à chaque
 * keystroke. Defaut 250 ms — valeur imposée par le contrat front/back du
 * lookup.
 */
export function useDebouncedValue<T>(value: T, delay: number = 250): T {
  const [debounced, setDebounced] = useState<T>(value);

  useEffect(() => {
    const timer = setTimeout(() => setDebounced(value), delay);
    return () => clearTimeout(timer);
  }, [value, delay]);

  return debounced;
}

export default useDebouncedValue;
